import {
	Dialog,
	IconButton,
	makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect, useState } from "react";

import { BlockPicker } from "react-color";

const useStyles = makeStyles(() => ({
	root: {
		position: "relative",
		padding: 8,
	},
	closeButton: {
		position: "absolute",
		top: 2,
		right: 2,
		zIndex: 2,
		padding: 4,
		boxShadow: "0 1px 4px rgba(0, 0, 0, 0.22)",
	},
}));

const ColorPicker = ({ onChange, currentColor, handleClose, open }) => {
	const classes = useStyles();
	const [selectedColor, setSelectedColor] = useState(currentColor);

	useEffect(() => {
		setSelectedColor(currentColor);
	}, [currentColor, open]);

	const hexToRgb = (hex) => {
		const safeHex = String(hex || "").replace("#", "");
		if (safeHex.length !== 6) return { r: 255, g: 255, b: 255 };

		return {
			r: parseInt(safeHex.slice(0, 2), 16),
			g: parseInt(safeHex.slice(2, 4), 16),
			b: parseInt(safeHex.slice(4, 6), 16),
		};
	};

	const toHex = (value) => value.toString(16).padStart(2, "0");

	const getComplementary = (hex) => {
		const { r, g, b } = hexToRgb(hex);
		return `#${toHex(255 - r)}${toHex(255 - g)}${toHex(255 - b)}`;
	};

	const getReadableTextColor = (hex) => {
		const { r, g, b } = hexToRgb(hex);
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
		return luminance > 0.6 ? "#111111" : "#ffffff";
	};

	const closeBackground = getComplementary(selectedColor || currentColor || "#ffffff");
	const closeIconColor = getReadableTextColor(closeBackground);

	const handleChange = color => {
		setSelectedColor(color.hex);
		handleClose();
	};

	const colors = [
		"#B80000",
		"#DB3E00",
		"#FCCB00",
		"#008B02",
		"#006B76",
		"#1273DE",
		"#004DCF",
		"#5300EB",
		"#EB9694",
		"#FAD0C3",
		"#FEF3BD",
		"#C1E1C5",
		"#BEDADC",
		"#C4DEF6",
		"#BED3F3",
		"#D4C4FB",
		"#4D4D4D",
		"#999999",
		"#F44E3B",
		"#FE9200",
		"#FCDC00",
		"#DBDF00",
		"#A4DD00",
		"#68CCCA",
		"#73D8FF",
		"#AEA1FF",
		"#FDA1FF",
		"#333333",
		"#808080",
		"#cccccc",
		"#D33115",
		"#E27300",
		"#FCC400",
		"#B0BC00",
		"#68BC00",
		"#16A5A5",
		"#009CE0",
		"#7B64FF",
		"#FA28FF",
		"#666666",
		"#B3B3B3",
		"#9F0500",
		"#C45100",
		"#FB9E00",
		"#808900",
		"#194D33",
		"#0C797D",
		"#0062B1",
		"#653294",
		"#AB149E",
	];

	return (
		<Dialog
			onClose={() => handleClose()}
			aria-labelledby="simple-dialog-title"
			open={open}
			PaperProps={{ style: { overflow: "visible" } }}
		>
			<div className={classes.root}>
				<IconButton
					size="small"
					aria-label="close color picker"
					onClick={handleClose}
					className={classes.closeButton}
					style={{ backgroundColor: closeBackground, color: closeIconColor }}
				>
					<CloseIcon fontSize="small" />
				</IconButton>
				<BlockPicker
					width={"100%"}
					triangle="hide"
					color={selectedColor}
					colors={colors}
					onChange={handleChange}
					onChangeComplete={color => onChange(color.hex)}
				/>
			</div>
		</Dialog>
	);
};

export default ColorPicker;
